import MultiplierInput from './MultiplierInput';

export default MultiplierInput;
